var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71457 15.8571C5.22109 15.8571 5.72266 15.7573 6.19063 15.5635C6.6586 15.3697 7.08381 15.0855 7.44198 14.7274C7.80015 14.3692 8.08426 13.944 8.2781 13.476C8.47194 13.0081 8.57171 12.5065 8.57171 12C8.57171 11.4934 8.47194 10.9919 8.2781 10.5239C8.08426 10.0559 7.80015 9.63072 7.44198 9.27255C7.08381 8.91438 6.6586 8.63027 6.19063 8.43643C5.72266 8.24259 5.22109 8.14282 4.71457 8.14282C3.69159 8.14282 2.71051 8.5492 1.98715 9.27255C1.2638 9.99591 0.857422 10.977 0.857422 12C0.857422 13.0229 1.2638 14.004 1.98715 14.7274C2.71051 15.4507 3.69159 15.8571 4.71457 15.8571Z",
    stroke: "#EFBC51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2859 23.143C20.3088 23.143 21.2899 22.7366 22.0133 22.0133C22.7366 21.2899 23.143 20.3088 23.143 19.2859C23.143 18.2629 22.7366 17.2818 22.0133 16.5584C21.2899 15.8351 20.3088 15.4287 19.2859 15.4287C18.2629 15.4287 17.2818 15.8351 16.5584 16.5584C15.8351 17.2818 15.4287 18.2629 15.4287 19.2859C15.4287 20.3088 15.8351 21.2899 16.5584 22.0133C17.2818 22.7366 18.2629 23.143 19.2859 23.143Z",
    stroke: "#EFBC51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2859 8.57146C20.3088 8.57146 21.2899 8.16509 22.0133 7.44173C22.7366 6.71838 23.143 5.7373 23.143 4.71432C23.143 3.69134 22.7366 2.71026 22.0133 1.98691C21.2899 1.26355 20.3088 0.857178 19.2859 0.857178C18.2629 0.857178 17.2818 1.26355 16.5584 1.98691C15.8351 2.71026 15.4287 3.69134 15.4287 4.71432C15.4287 5.7373 15.8351 6.71838 16.5584 7.44173C17.2818 8.16509 18.2629 8.57146 19.2859 8.57146Z",
    stroke: "#EFBC51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16016 10.2859L15.8402 6.42871",
    stroke: "#EFBC51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16016 13.7144L15.8402 17.5715",
    stroke: "#EFBC51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.fa00871ed82ee78433294bec6da86213.svg";
export { ForwardRef as ReactComponent };